import { parseZoneInfo as f, formatOffset as o } from "./contact-channels128.js";
import a from "./contact-channels138.js";
let r = null;
class n extends a {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return r === null && (r = new n()), r;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: t, locale: s }) {
    return f(e, t, s);
  }
  /** @override **/
  formatOffset(e, t) {
    return o(this.offset(e), t);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
export {
  n as default
};
//# sourceMappingURL=contact-channels140.js.map
